import { Grid, Typography } from '@mui/material';
import CusFormField from 'components/CusFormField';
import MainCard from 'components/MainCard';
import useMain from 'hooks/useMain';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { userAdminService } from 'services/userAdmin';
import { handleAsyncCall } from 'utils/common';
import { profileFields } from './field';

const Support = () => {
  const {
    control,
    setError,
    handleSubmit,
    getValues,
    formState: { errors },
    reset,
    watch
  } = useForm({});
  const { t, upperCaseLang } = useMain();

  const onSubmit = (data) => {};
  useEffect(() => {
    handleAsyncCall({
      service: userAdminService.getUserDetail,
      successCb: (res) => {
        const details = {
          CompanyName: res?.data[`CompanyName${upperCaseLang}`],
          ...res?.data
        };
        reset(details);
      }
    });
  }, []);

  return (
    <MainCard title={t('SUPPORT')}>
      <Typography variant="h6" mb={2}>
        {t('CONTACT_INFO')}
      </Typography>
      <Grid container>
        {Object.entries({
          [`${t('NAME')}`]: 'Loren Law',
          [`${t('MOBILE')}`]: '852-21575898',
          [`${t('EMAIL')}`]: 'loren.law@shuion.com.hk'
        }).map(([key, value]) => (
          <Grid item xs={12} key={`support-${key}`}>
            <Typography variant="body1"> {`${key}: ${value}`}</Typography>
          </Grid>
        ))}
      </Grid>
    </MainCard>
  );
};

export default Support;
